import styled from 'styled-components';

export const AppLoadingStyle = {
  Container: styled.div`
    height: 100vh;
    width: 100%;
    display: grid;
    place-items: center;
  `,
};
